export enum PermissionsColpatria {
  gestion = 6002,
  deposito = 6001,
  venta_pines = 6003,
  recaudo = 6004,
  pago_giro = 6005,
}
